import { NavLink, Navigate, Route, Routes } from "react-router-dom";

import { Alertas } from "./paginas/Alertas.tsx";
import { Auditoria } from "./paginas/Auditoria.tsx";
import { Chaves } from "./paginas/Chaves.tsx";
import { Empresa } from "./paginas/Empresa.tsx";
import { Empresas } from "./paginas/Empresas.tsx";
import { Licenca } from "./paginas/Licenca.tsx";
import { Login } from "./paginas/Login.tsx";
import { Maquina } from "./paginas/Maquina.tsx";
import { Maquinas } from "./paginas/Maquinas.tsx";
import { Painel } from "./paginas/Painel.tsx";
import { Telemetria } from "./paginas/Telemetria.tsx";
import { TrocarSenha } from "./paginas/TrocarSenha.tsx";
import { Uso } from "./paginas/Uso.tsx";
import { Usuarios } from "./paginas/Usuarios.tsx";
import { ProvedorSessao, ehAdmin, useSessao } from "./sessao.tsx";

export function App() {
  return (
    <ProvedorSessao>
      <Conteudo />
    </ProvedorSessao>
  );
}

function Conteudo() {
  const { usuario, carregando } = useSessao();

  if (carregando) return <div className="carregando">carregando...</div>;
  if (!usuario) return <Login />;
  if (usuario.precisa_trocar_senha) return <TrocarSenha />;

  return (
    <>
      <BarraTopo />
      <div className="corpo">
        <Navegacao />
        <main className="conteudo">
          <Routes>
            <Route path="/" element={<Painel />} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/empresas/:id" element={<Empresa />} />
            <Route path="/licencas/:id" element={<Licenca />} />
            <Route path="/maquinas" element={<Maquinas />} />
            <Route path="/maquinas/:id" element={<Maquina />} />
            <Route path="/telemetria" element={<Telemetria />} />
            <Route path="/uso" element={<Uso />} />
            <Route path="/alertas" element={<Alertas />} />
            <Route path="/auditoria" element={<Auditoria />} />
            {ehAdmin(usuario) && <Route path="/usuarios" element={<Usuarios />} />}
            {ehAdmin(usuario) && <Route path="/chaves" element={<Chaves />} />}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </>
  );
}

function BarraTopo() {
  const { usuario, sair } = useSessao();
  const papel = { admin: "Administrador", suporte: "Suporte", leitura: "Consulta" };
  return (
    <header className="barra-topo">
      <div className="barra-topo__marca">
        <NavLink to="/"><img src="/logo-conceitto.webp" alt="Conceitto" className="barra-topo__logo" /></NavLink>
        <span className="barra-topo__sub">Licencas &middot; Automatiza 3.0</span>
      </div>
      <div className="barra-topo__direita">
        <span className="barra-topo__usuario">
          {usuario?.nome} &middot; {papel[usuario?.papel as keyof typeof papel] ?? usuario?.papel}
        </span>
        <button className="botao botao--fantasma botao--pequeno" type="button"
                onClick={() => void sair()}>Sair</button>
      </div>
    </header>
  );
}

function Navegacao() {
  const { usuario, alertasAbertos } = useSessao();
  const cls = ({ isActive }: { isActive: boolean }) =>
    `navegacao__item${isActive ? " navegacao__item--ativo" : ""}`;

  return (
    <nav className="navegacao">
      <NavLink to="/" end className={cls}>Painel</NavLink>
      <NavLink to="/empresas" className={cls}>Empresas</NavLink>
      <NavLink to="/maquinas" className={cls}>Maquinas</NavLink>
      <NavLink to="/telemetria" className={cls}>Telemetria</NavLink>
      <NavLink to="/uso" className={cls}>Uso e ocupacao</NavLink>
      <NavLink to="/alertas" className={cls}>
        Alertas
        {alertasAbertos > 0 && <span className="navegacao__contagem">{alertasAbertos}</span>}
      </NavLink>
      <NavLink to="/auditoria" className={cls}>Auditoria</NavLink>
      {ehAdmin(usuario) && <NavLink to="/usuarios" className={cls}>Usuarios</NavLink>}
      {ehAdmin(usuario) && <NavLink to="/chaves" className={cls}>Chaves</NavLink>}
    </nav>
  );
}
